import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { AccessControlController } from '@shared/src/controllers/accesscontrol/accesscontrol.controller';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { HColor } from '@shared/src/datatypes/HColor';
import { HLong } from '@shared/src/datatypes/HLong';
import { AccessControlPhaseTransitionDto } from '@shared/src/dtos/accesscontrol/AccessControlPhaseTransitionDto';
import { AccessControlPhaseTransitionsDto } from '@shared/src/dtos/accesscontrol/AccessControlPhaseTransitionsDto';
import { SetPlateGateDto } from '@shared/src/dtos/accesscontrol/SetPlateGateDto';
import { ForkliftRouteDetailDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftRouteDetailDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';

@Component({
  selector: 'shared-accesscontrol-transitions',
  templateUrl: './shared.accesscontrol.transitions.component.html',
  styleUrls: ['./shared.accesscontrol.transitions.component.scss']
})
export class SharedAccessControlTransitionsComponent {

  constructor(private accessControlController: AccessControlController,
    @Inject('HomeController') protected homeController: HomeController) { }

  @Output() refresh = new EventEmitter<boolean>();
  @Output() phaseChanged = new EventEmitter<number>();

  public data: AccessControlPhaseTransitionsDto | null = null;

  private _accessControlId: number = 0;
  public get accessControlId(): number {
    return this._accessControlId;
  }
  @Input()
  public set accessControlId(value: number) {
    if (this._accessControlId === value)
      return;
    this._accessControlId = value;
    this.loadDataIfReady();
  }

  private _phaseId: number = 0;
  public get phaseId(): number {
    return this._phaseId;
  }
  @Input()
  public set phaseId(value: number) {
    if (this._phaseId === value)
      return;
    this._phaseId = value;
    this.loadDataIfReady();
  }

  public getBackColor(value: any): string {
    return HColor.getColor(value, '#eeeeee');
  }

  public getForeColor(value: any): string {
    return HColor.getColor(value, '#000000');
  }

  private loadDataIfReady() {
    if (HLong.isNullOrNullLong(this._accessControlId) || HLong.isNullOrNullLong(this._phaseId)) {
      this.data = null;
      return;
    }
    this.accessControlController.getPhaseTransitions(this._accessControlId, this._phaseId).subscribe(result => {
      this.data = AccessControlPhaseTransitionsDto.build(result);
    });
  }

  onTransitionClick(t: AccessControlPhaseTransitionDto) {
    this.accessControlController.executeTransition(t.accessControlTransitionId, this.phaseId).subscribe((result: ForkliftRouteDetailDto) => {
      if (result != null) {
        if (!HLong.isNullOrNullLong(result.phaseId))
          this.phaseChanged.emit(result.phaseId);
        this.loadDataIfReady();
        this.refresh.next(true);
        this.homeController.onForkliftChanged$.next(this._accessControlId);
      }
    });
  }
  onGateClick(t: AccessControlPhaseTransitionDto) {
    if (t == null)
      return;
    //Si està dins, hem de sortir
    if (!t.entra) {
      this.accessControlController.exitPlateGate(SetPlateGateDto.build(t.accessControlId, "", this.data?.routeId, this.data?.phaseId, 0, t.gateId)).subscribe(data => {
        if (data) {
          this.loadDataIfReady();
          this.refresh.next(true);
          this.homeController.onForkliftChanged$.next(this._accessControlId);
        }
      });
    } else {
      this.accessControlController.entryPlateGate(SetPlateGateDto.build(t.accessControlId, "", this.data?.routeId, this.data?.phaseId, t.gateId, 0)).subscribe(data => {
        if (data) {
          this.loadDataIfReady();
          this.refresh.next(true);
          this.homeController.onForkliftChanged$.next(this._accessControlId);
        }
      });
    }
  }

  onClickAction($event: ActionDto) {
    if ($event == null || this.data == null)
      return;
    this.accessControlController.executeTransitionAction(this.data.phaseId, this.data.accessControlId, $event.actionId).subscribe(data => {
      this.loadDataIfReady();
      this.refresh.next(true);
      this.homeController.onForkliftChanged$.next(this._accessControlId);
    });
  }


  onReservar() {
    if (this.data == null || HLong.isNullOrNullLong(this.data.phaseId) || HLong.isNullOrNullLong(this.accessControlId))
      return;
    this.accessControlController.executeTransitionAction(this.data.phaseId, this.data.accessControlId!, 'MILLORARRESERVAR').subscribe(data => {
      this.refresh.next(true);
    });
  }

  onViewActiveSlots() {
    if (this.data == null || HLong.isNullOrNullLong(this.data.routeId))
      return;
    window.open(this.homeController.createRouteIdLinkToActiveSlots(this.data.routeId), '_blank');
  }

  onViewActiveRoutes() {
    if (this.data == null || HLong.isNullOrNullLong(this.data.routeId))
      return;
    window.open(this.homeController.createRouteIdLinkToActiveRoutes(this.data.routeId), '_blank');
  }
}
